<div *ngIf='(vm$ | async) as vm'>

    <app-page-header [vm]="vm" title='Payroll' [canGoBack]="true" [canRefresh]="true"
        [subTitle]="vm.timesheetVm?.payrollInfo?.payrollDate ? 'Timesheet - ' + vm.timesheetVm.payrollInfo.payrollDate : 'Loading timesheet...'"
        (refreshClick)="refreshPage()"></app-page-header>

    <div *ngIf="vm.workingText">
        <span>{{vm.workingText}}</span>
    </div>
    <div *ngIf="vm.errorText">
        <h1 class="text-danger">{{vm.errorText}}</h1>
    </div>

    <div *ngIf="!vm.workingText && !vm.errorText">
        <div *ngIf="vm.timesheetVm as ts">
            <div class="row">
                <!-- Rest Breaks -->
                <div class="col-md-6 pt-3" *ngIf="ts.data.driverBreakDay.restBreakInfo as rbi">
                    <mdb-card narrower="true" cascade="true">
                        <div class="row align-items-center">
                            <div class="col-10 col-md-10">
                                <app-card-header title="My Rest Breaks for the Day" [headingSize]="6"></app-card-header>
                            </div>
                            <div class="col-2 col-md-2 text-end"></div>
                        </div>
                        <mdb-card-body cascade="true">
                            <div class="note note-primary mb-3">
                                <strong>Note:</strong>
                                I was authorized and permitted to take 10 minute, uninterrupted, duty-free rest breaks
                                for every four hours or major fraction thereof that I worked during my workday.
                                Based on my shift length of {{ formatMinutes(ts.payrollInfo.totalDayMinutes) }}, I
                                understand that I was entitled to take
                                {{ ts.numberOfRestBlocks }} rest breaks during my shift. I was not prevented from taking
                                any of my rest breaks.
                            </div>
                            <div class="row mb-0">
                                <div class="col-md-12 d-flex justify-content-left">
                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxRestAgree"
                                        (change)="onRestAgreeChange(ts)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        <span class="text-danger">Agree</span>
                                    </mdb-checkbox>

                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxRestDisagree"
                                        (change)="onRestDisagreeChange(ts)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        <span class="text-danger">Disagree</span>
                                    </mdb-checkbox>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-md-12" style="margin-top: -6px;">
                                    <app-form-input [vm]="ts.inputRestViewModel.commentsInputVm"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo"></app-form-input>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
                <!-- Meal Breaks -->
                <div class="col-md-6 pt-3" *ngIf="ts.data.driverBreakDay.mealBreakInfo as mbi">
                    <mdb-card narrower="true" cascade="true">
                        <div class="row align-items-center">
                            <div class="col-10 col-md-10">
                                <app-card-header title="My Meal Breaks for the Day" [headingSize]="6"></app-card-header>
                            </div>
                            <div class="col-2 col-md-2 text-end">
                                <a *ngIf="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked" href="javascript:void(0)"
                                    (click)="addBreakClicked(0, vm)">
                                    <u>add</u>
                                </a>
                            </div>
                        </div>
                        <mdb-card-body cascade="true">
                            <div class="note note-primary mb-3">
                                <strong>Note:</strong>
                                Based on my shift length of {{ formatMinutes(ts.payrollInfo.totalDayMinutes) }},
                                I understand that I was entitled to take {{ ts.numberOfMealBlocks > 2 ? 2 :
                                ts.numberOfMealBlocks }} 30-minute, uninterrupted,
                                duty-free meal breaks.
                                I was not prevented from taking my first meal break within the first 5 hours of my
                                shift. I also was not prevented
                                from taking any other meal breaks to which I may have been entitled. The start and end
                                times for my meal break(s) are listed below.
                            </div>
                            <div class="d-flex justify-content-center">
                                <div class="table-responsive">
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">Start</th>
                                                <th scope="col">End</th>
                                                <th scope="col">Length</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let bb of mbi.breaksBefore" [ngClass]="{
                                                    'text-danger': bb.errorText?.length > 0,
                                                    'text-primary': bb.warningText?.length > 0 && (!bb.errorText || bb.errorText.length === 0)
                                                    }">
                                                <td>
                                                    <u><a *ngIf="bb.startAt?.time" href="javascript:void(0)" [ngStyle]="{
                                                                'text-decoration': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'underline',
                                                                'pointer-events': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'auto',
                                                                'color': ((!bb.endAt?.time || bb.endAt?.time?.length == 0) && !vm.timesheetVm?.payrollInfo?.payrollPeriodLocked) ? 'red' : (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'black' : 'inherit')
                                                            }"
                                                            (click)="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked && editBreakTimeClicked(bb.id, vm)"
                                                            [title]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'Locked - cannot edit' : ''">
                                                            {{ bb.startAt.time }}
                                                        </a></u>
                                                </td>
                                                <td>
                                                    <u><a *ngIf="bb.endAt?.time" href="javascript:void(0)" [ngStyle]="{
                                                                'text-decoration': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'underline',
                                                                'pointer-events': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'auto',
                                                                'color': ((!bb.endAt?.time || bb.endAt?.time?.length == 0) && !vm.timesheetVm?.payrollInfo?.payrollPeriodLocked) ? 'red' : (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'black' : 'inherit')
                                                            }"
                                                            (click)="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked && editBreakTimeClicked(bb.id, vm)"
                                                            [title]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'Locked - cannot edit' : ''">
                                                            {{ bb.endAt.time }}
                                                        </a></u>
                                                </td>
                                                <td *ngIf="bb.durationMinutes">
                                                    <span>{{ bb.durationMinutes | minToTime }}</span>
                                                </td>
                                                <td *ngIf="bb.errorText?.length > 0 || bb.warningText?.length > 0">
                                                    <span>{{ bb.errorText ? bb.errorText :
                                                        bb.warningText ? bb.warningText : '' }}</span>
                                                </td>
                                            </tr>
                                            <ng-container *ngFor="let w of mbi.windows">
                                                <tr *ngFor="let t of w.breaks" [ngClass]="{
                                                    'text-danger': t.errorText?.length > 0,
                                                    'text-primary': t.warningText?.length > 0 && (!t.errorText || t.errorText.length === 0)
                                                    }">
                                                    <td>
                                                        <a href="javascript:void(0)" [ngStyle]="{
                                                                'text-decoration': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'underline',
                                                                'pointer-events': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'auto',
                                                                'color': ((!t.endAt?.time || t.endAt?.time?.length == 0) && !vm.timesheetVm?.payrollInfo?.payrollPeriodLocked) ? 'red' : (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'black' : 'inherit')
                                                            }"
                                                            (click)="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked && editBreakTimeClicked(t.id, vm)"
                                                            [title]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'Locked - cannot edit' : ''">
                                                            {{ t.startAt?.time }}
                                                        </a>
                                                    </td>
                                                    <td><a *ngIf="t.endAt?.time?.length > 0" href="javascript:void(0)"
                                                            [ngStyle]="{
                                                                'text-decoration': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'underline',
                                                                'pointer-events': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'auto',
                                                                'color': (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'black' : 'inherit')
                                                            }"
                                                            (click)="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked && editBreakTimeClicked(t.id, vm)"
                                                            [title]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'Locked - cannot edit' : ''">
                                                            {{ t.endAt?.time }}
                                                        </a>
                                                    </td>
                                                    <td *ngIf="t.durationMinutes">
                                                        <span>{{ t.durationMinutes | minToTime }}</span>
                                                    </td>
                                                    <td *ngIf="t.errorText?.length > 0 || t.warningText?.length > 0">
                                                        <span>{{ t.errorText ? t.errorText :
                                                            t.warningText ? t.warningText : '' }}</span>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <tr *ngFor="let ba of mbi.breaksAfter">
                                                <td>
                                                    <u><a *ngIf="ba.startAt?.time" href="javascript:void(0)" [ngStyle]="{
                                                                'text-decoration': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'underline',
                                                                'pointer-events': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'auto',
                                                                'color': ((!ba.endAt?.time || ba.endAt?.time?.length == 0) && !vm.timesheetVm?.payrollInfo?.payrollPeriodLocked) ? 'red' : (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'black' : 'inherit')
                                                            }"
                                                            (click)="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked && editBreakTimeClicked(ba.id, vm)"
                                                            [title]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'Locked - cannot edit' : ''">
                                                            {{ ba.startAt.time }}
                                                        </a></u>
                                                </td>
                                                <td>
                                                    <u><a *ngIf="ba.endAt?.time" href="javascript:void(0)" [ngStyle]="{
                                                                'text-decoration': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'underline',
                                                                'pointer-events': vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'none' : 'auto',
                                                                'color': ((!ba.endAt?.time || ba.endAt?.time?.length == 0) && !vm.timesheetVm?.payrollInfo?.payrollPeriodLocked) ? 'red' : (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'black' : 'inherit')
                                                            }"
                                                            (click)="!vm.timesheetVm?.payrollInfo?.payrollPeriodLocked && editBreakTimeClicked(ba.id, vm)"
                                                            [title]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked ? 'Locked - cannot edit' : ''">
                                                            {{ ba.endAt.time }}
                                                        </a></u>
                                                </td>
                                                <td *ngIf="ba.durationMinutes">
                                                    <span>{{ ba.durationMinutes | minToTime }}</span>
                                                </td>
                                                <td *ngIf="ba.errorText?.length > 0 || ba.warningText?.length > 0">
                                                    <span>{{ ba.errorText ? ba.errorText :
                                                        ba.warningText ? ba.warningText : '' }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row mb-3"
                                *ngIf="vm.timesheetVm?.mealMessage?.errorMessage && vm.timesheetVm?.mealMessage?.errorMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-left">
                                    <span class="text-danger">{{vm.timesheetVm?.mealMessage?.errorMessage}}</span>
                                </div>
                            </div>
                            <div class="row mb-0"
                                *ngIf="vm.timesheetVm?.mealMessage?.workMessage && vm.timesheetVm?.mealMessage?.workMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-center">
                                    <span class="text-info">{{vm.timesheetVm.mealMessage.workMessage}}</span>
                                </div>
                            </div>
                            <div class="row mb-0">
                                <div class="col-md-12 d-flex justify-content-left">
                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxMealAgree"
                                        (change)="onMealAgreeChange(ts, vm)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        <span class="text-danger">Agree</span>
                                    </mdb-checkbox>

                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxMealDisagree"
                                        (change)="onMealDisagreeChange(ts)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        <span class="text-danger">Disagree</span>
                                    </mdb-checkbox>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-md-12" style="margin-top: -6px;">
                                    <app-form-input [vm]="ts.inputMealViewModel.commentsInputVm"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo"></app-form-input>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
                <!-- Day Info -->
                <div class="col-md-6 pt-2">
                    <mdb-card narrower="true" cascade="true">
                        <div class="row align-items-center">
                            <div class="col-10 col-md-10">
                                <app-card-header title="My Trips for the Day" [headingSize]="6"></app-card-header>
                            </div>
                            <div class="col-2 col-md-2 text-end"></div>
                        </div>
                        <mdb-card-body cascade="true">
                            <div class="table-responsive" *ngIf="ts.data.driverBreakDay.dayInfo as di">
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">Row #</th>
                                            <th scope="col">From</th>
                                            <th scope="col">Time</th>
                                            <th scope="col"></th>
                                            <th scope="col">Time</th>
                                            <th scope="col">To</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let c of di.rows">
                                            <td>{{ c.rowInfo.row }}</td>
                                            <td>{{ getLabel(c.fromInfo.subTitle, c.fromInfo.title) }}</td>
                                            <td>{{ c.fromInfo.at.time }}</td>
                                            <td></td>
                                            <td>{{ c.toInfo.at.time }}</td>
                                            <td>{{ getLabel(c.toInfo.subTitle, c.toInfo.title) }}</td>
                                            <!-- <td>{{ c.gapInfo.minutes }}</td> -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row mb-0">
                                <div class="col-md-12 d-flex justify-content-start">
                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxReportIssues"
                                        (change)="onReportIssueshange(ts)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        Report Issues
                                    </mdb-checkbox>
                                </div>
                            </div>

                            <div class="row mt-0">
                                <div class="col-md-12" style="margin-top: -6px;">
                                    <app-form-input [vm]="ts.inputMyTripsViewModel.commentsInputVm"></app-form-input>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
                <!-- Sign form -->
                <div class="col-md-6 pt-3">
                    <mdb-card narrower="true" cascade="true">
                        <div class="row align-items-center">
                            <div class="col-10 col-md-10">
                                <app-card-header title="My Signature" [headingSize]="6"></app-card-header>
                            </div>
                            <div class="col-2 col-md-2 text-end"></div>
                        </div>
                        <mdb-card-body cascade="true">
                            <div class="row" *ngIf="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked">
                                <div class="col-md-3">
                                    Signed:
                                </div>
                                <div class="col-md-9">
                                    {{vm.timesheetVm.data.signedDateTimeLocal | date: 'MM/dd/yyyy HH:mm' }}
                                </div>
                            </div>
                            <div class="row justify-content-center"
                                *ngIf="vm.timesheetVm.payrollInfo && vm.timesheetVm.payrollInfo.issuesCount == 0">
                                <div class="col-md-6">
                                    <div class="alert alert-danger p-3 text-start"
                                        *ngIf="getIssues(vm.timesheetVm.payrollInfo.issues).length > 0">
                                        <ul class="mb-0">
                                            <li *ngFor="let issue of getIssues(vm.timesheetVm.payrollInfo.issues)">⚠️ {{
                                                issue }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="alert alert-info fs-6 rounded-3 shadow-sm px-3 py-2">
                                <i class="fas fa-info-circle me-2"></i>
                                I have reviewed my timesheet, and it accurately reflects all hours that I worked and all
                                meal periods that I took for my workday.
                            </div>
                            <div class="row mb-0">
                                <div class="col-md-12 d-flex justify-content-left">
                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxSignAgree"
                                        (change)="onSignAgreeChange(ts)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        <span class="text-danger">Agree</span>
                                    </mdb-checkbox>

                                    <mdb-checkbox class="mx-1" [(ngModel)]="ts.checkboxSignDisagree"
                                        (change)="onSignDisagreeChange(ts)"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo">
                                        <span class="text-danger">Disagree</span>
                                    </mdb-checkbox>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <div class="col-md-12" style="margin-top: -6px;">
                                    <app-form-input [vm]="ts.inputSignViewModel.commentsInputVm"
                                        [disabled]="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked || vm.timesheetVm?.data?.driverBreakDay?.signInfo"></app-form-input>
                                </div>
                            </div>
                            <div class="row mb-3" *ngIf="vm.signMessage && vm.signMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-left">
                                    <span class="text-danger">{{vm.signMessage}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 d-flex justify-content-center mt-3">
                                    <button style="margin-top:-5px; width: 150px;" mdbBtn type="button" color="info"
                                        rounded="true" outline="true" size="sm" mdbWavesEffect class="btn-block"
                                        [disabled]="enableSignButton(vm)" (click)="signTimeSheet(vm)">
                                        Sign
                                    </button>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
                <!-- Report Issue -->
                <div class="col-md-6 pt-3" *ngIf="vm.timesheetVm?.payrollInfo?.payrollPeriodLocked">
                    <mdb-card narrower="true" cascade="true">
                        <app-card-header title="Report Issue" [headingSize]="6"></app-card-header>
                        <mdb-card-body cascade="true">
                            <div class="row mt-0">
                                <div class="col-md-12" style="margin-top: -6px;">
                                    <app-form-input
                                        [vm]="ts.inputReportIssueViewModel.commentsInputVm"></app-form-input>
                                </div>
                            </div>
                            <div class="row mb-1" *ngIf="vm.updateMessage && vm.updateMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-center">
                                    <span class="text-success">{{ vm.updateMessage }}</span>
                                </div>
                            </div>
                            <div class="row mb-1" *ngIf="vm.errorMessage && vm.errorMessage.length > 0">
                                <div class="col-md-12 d-flex justify-content-center">
                                    <span class="text-danger">{{ vm.errorMessage }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 d-flex justify-content-center mt-3">
                                    <button style="margin-top:-5px; width: 150px;" mdbBtn type="button" color="info"
                                        rounded="true" outline="true" size="sm" mdbWavesEffect class="btn-block"
                                        (click)="submitReportIssue(vm)">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>
    </div>
</div>